/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';

import { PlayerPhoto } from 'common/react/components/PlayerPhoto';
import { useGetImageScale } from 'widgets/team-lineups-v2/js/utils/use-get-image-scale';

export const InsAndOutsPlayer = ({ player, reason }) => {
    const imageScale = useGetImageScale();

    return (
        <div className="team-lineups-ins-and-outs__grid-item-wrapper">
            <div className="team-lineups-ins-and-outs__player-name-wrapper">
                <p className="team-lineups-ins-and-outs__player-name">
                    {player.playerName.givenName} {player.playerName.surname}
                </p>
                {reason ? (
                    <p className="team-lineups-ins-and-outs__player-reason">
                        {reason}
                    </p>
                ) : null}
            </div>
            <div className="team-lineups-ins-and-outs__headshot">
                <PlayerPhoto
                    photoUrl={player.photoURL}
                    alt={`${player?.playerName?.givenName} ${player?.playerName?.surname}`}
                    scale={imageScale}
                />
            </div>
        </div>
    );
};

InsAndOutsPlayer.propTypes = {
    player: PropTypes.object.isRequired,
    reason: PropTypes.string,
    match: PropTypes.object,
    isAFLW: PropTypes.bool
};
